import React, { useState, useEffect, act } from 'react';

const InfoPopup = ({  onConfirm, title, message, icon }) => {

    useEffect(() => {
        // Fetch data if necessary
    }, []);

    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <div className='popupParent'>
            {/* <h2 className='popupTitle'>TITLE PLACEHOLDER</h2> */}
            <div className='popupWarningIcon'>
                <img src={icon}/>
            </div>
            <div className='popupBody'>
                <div className='popupTexts'>
                    <div className='popupMainText'>{title}</div>
                    <div className='popupSubText'>{message}</div>
                </div>
            </div>

            <div className='buttonDiv'>
                <button className='actionButton' onClick={handleConfirm}>CONFIRM</button>
                {/* <button className='delete popDelete' onClick={handleClose}>CLOSE</button> */}
            </div>
        </div>
    );
};

export default InfoPopup;